import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import { useI18n } from './composables/useI18n'

// Remove the no-JS fallback class now that JavaScript is running.
document.documentElement.classList.remove('no-js')

const { locale } = useI18n()
if (typeof document !== 'undefined') {
  document.documentElement.lang = locale.value
}

createApp(App).mount('#app')
